import { gcdDependencies, create } from 'mathjs';

// This ensures we get a minimal mathjs bundle for just what we need (see https://mathjs.org/docs/custom_bundling.html)
const { gcd } = create({ gcdDependencies });
export { gcd };
